import { Alert, Box, ConditionWrapper, RichEditorView, Text } from '@approvalmax/ui/src/components';
import { usePageRedesign } from 'pages/requestForm/hooks/usePageRedesign';
import { memo } from 'react';
import bemFactory from 'react-bem-factory';

import { messages } from './RequesterInstructionSection.messages';
import { RequesterInstructionSectionProps } from './RequesterInstructionSection.types';

const qa = bemFactory.qa('reqf-requester-instruction-section');

export const RequesterInstructionSection = memo<RequesterInstructionSectionProps>((props) => {
    const { instructionText } = props;

    const { isPageRedesign } = usePageRedesign();

    if (!instructionText) return null;

    return (
        <Alert color='midnight20' size='small' data-qa={qa()}>
            <ConditionWrapper
                condition={!isPageRedesign}
                wrapperIf={(children) => <Box spacing='0 44'>{children}</Box>}
            >
                <Text font='label' fontWeight='medium' spacing='0 0 4'>
                    {messages.headerText}
                </Text>

                <Text font='body' fontSize='small' data-qa={qa('text')}>
                    <RichEditorView highlightUrls html={instructionText} />
                </Text>
            </ConditionWrapper>
        </Alert>
    );
});

RequesterInstructionSection.displayName = 'RequesterInstructionSection';
